import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { httpClient } from 'utils/http/httpClient';
import type { LightweightEvent } from 'utils/streaming/model';

export interface PollingApi {
  getLastPollingMessage(): Observable<LightweightEvent[]>;
}
export const pollingApi: PollingApi = {
  getLastPollingMessage(): Observable<LightweightEvent[]> {
    const pollingUrl = 'api/v1/events/last';
    return httpClient
      .getJSON<LightweightEvent[]>({
        url: pollingUrl,
      })
      .pipe(map(({ payload }) => payload));
  },
};
